// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .datepicker-range {\n    margin-right: 265px;\n  }\n  .root .datepicker-wrapper {\n    padding: 20px 20px 28px;\n    background: var(--secondary-color-darker-100);\n    box-shadow: inset 0px 1px 0 var(--secondary-color-darker-200),\n      0px 1px 0 var(--secondary-color-lighter-200);\n  }\n\n@media (max-width: 730px) {\n    .root .datepicker-range {\n      margin-right: 0;\n    }\n}\n", ""]);
// Exports
module.exports = exports;
